module.exports = __webpack_public_path__ + "img/outcome_requested_operator.88ef9499.svg";